import { IEmployeeData, IEmployeeFieldErrorData, IUserData } from '@/models';
import { IDepartmentData } from '../department';
import { State } from '../state/state';
import { IUserFieldErrorData } from '../user';
import { IWorkgroupData } from '../workgroup';

// API Data

export interface IPayrollChangeRequestStatusData {
  value: number;
  display_name?: string;
}

export interface IPayrollChangeRequestData {
  id?: number;
  state?: IPayrollChangeRequestStatus;
  employee?: IEmployeeData | number | null;
  from_department: IDepartmentData | null;
  to_department?: IDepartmentData | null;
  from_group?: IWorkgroupData | null;
  to_group?: IWorkgroupData | null;
  from_rate?: number | null;
  to_rate?: number | null;
  reason: string;
  additional_info?: string;
  owner?: IUserData | number;

  effective_date?: Date | string;
  created_at?: Date | string;
  updated_at?: Date | string;
  hr_personnel?: IUserData | number | null;
}

export interface IPayrollChangeRequestReasonFieldErrorData {
  description: string[];
}

export interface IPayrollChangeRequestFieldErrorData {
  employee?: IEmployeeFieldErrorData;
  from_department?: string[];
  to_department?: string[];
  from_group?: string[];
  to_group?: string[];
  from_rate?: string[];
  to_rate?: string[];
  reason: string[];
  additional_info?: string[];
  owner?: string[];

  effective_date?: string[];
  hr_personnel?: IUserFieldErrorData;
}

export interface PayrollChangeRequestFilterParams {
  state?: PayrollChangeRequestStatusEnum;
}

// Business Logic Interface
export interface IPayrollChangeRequest extends IPayrollChangeRequestData {
  validate(): boolean;
}

export interface IPayrollChangeRequestStatus
  extends IPayrollChangeRequestStatusData {
  getCurrentState(): State<PayrollChangeRequestStatusEnum>;
}

export interface IPayrollChangeRequestFieldError
  extends IPayrollChangeRequestFieldErrorData {
  clearErrors(): void;
}

// Constants - Used for validation
export const PAYROLL_CHANGE_REQUEST_LINE_ITEM_MAX_DESCRIPTION_LENGTH = 255;

export enum PayrollChangeRequestStatusEnum {
  Draft = 0,
  Submitted,
  InReview,
  Cancelled,
  Complete
}

export enum PayrollChangeRequestApprovalState {
  TENTATIVE = 0,
  COMPLETE,
  CANCELLED
}
